(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('training', {
            parent: 'training_menu',
            url: '/training?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.training.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training/trainings.html',
                    controller: 'TrainingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('trainingExamQuestion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('training-detail', {
            parent: 'training_menu',
            url: '/training/{id}',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.training.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training/training-detail.html',
                    controller: 'TrainingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('trainingExamQuestion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Training', function($stateParams, Training) {
                    return Training.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'training',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('training-detail.edit', {
            parent: 'training-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training/training-dialog.html',
                    controller: 'TrainingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Training', function(Training) {
                            return Training.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training.new', {
            parent: 'training',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training/training-dialog.html',
                    controller: 'TrainingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                trainingPoints: null,
                                validForYears: null,
                                trainingType: null,
                                id: null,
                                checklistItems: [],
                                examQuestions: [],
                                organization: null,
                                examPassRequiredPercent: null,
                                deleted:false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('training', null, { reload: 'training' });
                }, function() {
                    $state.go('training');
                });
            }]
        })
        .state('training.edit', {
            parent: 'training',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training/training-dialog.html',
                    controller: 'TrainingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Training', function(Training) {
                            return Training.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training', null, { reload: 'training' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training.delete', {
            parent: 'training',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training/training-delete-dialog.html',
                    controller: 'TrainingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Training', function(Training) {
                            return Training.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training', null, { reload: 'training' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
